import { render, staticRenderFns } from "./video_carousel.vue?vue&type=template&id=68ac9d16&scoped=true&"
import script from "./video_carousel.vue?vue&type=script&lang=js&"
export * from "./video_carousel.vue?vue&type=script&lang=js&"
import style0 from "./video_carousel.vue?vue&type=style&index=0&id=68ac9d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ac9d16",
  null
  
)

component.options.__file = "video_carousel.vue"
export default component.exports